import { useMemo } from 'react';

import type { ConfluenceFreePoolTargetExperimentGUPSQuery$data } from '../pre-upgrade-modal-graphql-query/__generated__/ConfluenceFreePoolTargetExperimentGUPSQuery.graphql.ts';

export const useIsEligibleViaGUPSForExperiment = (
	data: ConfluenceFreePoolTargetExperimentGUPSQuery$data | undefined,
): {
	isEligibleViaGUPS: boolean;
	analyticsAttributes: Record<string, any>;
} => {
	const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;

	const hasNoTrialHistory =
		Array.isArray(entitlement?.entitlementProfile?.trialHistory) &&
		entitlement?.entitlementProfile?.trialHistory.length === 0;

	const hasOnlyReverseTrialedWithoutPaidFeatureUsage =
		Array.isArray(entitlement?.entitlementProfile?.trialHistory) &&
		entitlement?.entitlementProfile?.trialHistory.length === 1 &&
		entitlement?.entitlementProfile?.trialHistory[0].trialType === 'REVERSE_TRIAL' &&
		Array.isArray(entitlement?.entitlementProfile?.paidFeatureUsage) &&
		entitlement?.entitlementProfile?.paidFeatureUsage?.length === 0;

	const memoizedAnalyticsAttributes = useMemo(() => {
		return {
			hasNoTrialHistory,
			hasOnlyReverseTrialedWithoutPaidFeatureUsage,
		};
	}, [hasNoTrialHistory, hasOnlyReverseTrialedWithoutPaidFeatureUsage]);

	return {
		isEligibleViaGUPS: Boolean(hasNoTrialHistory || hasOnlyReverseTrialedWithoutPaidFeatureUsage),
		analyticsAttributes: memoizedAnalyticsAttributes,
	};
};
